import { FC, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import styled from './index.module.scss';
import IconClose from './IconClose';
import IconTop1 from './IconTop1';
import IconTop2 from './IconTop2';
import IconTop3 from './IconTop3';
import { useLang } from '@/app/utils/useLang';
import { getCurrentPlanTop } from '@/service/referral';
import getLocal from '@/app/utils/getLocal';
interface IProps {
    planId: string;
    callback?: any;
}

const WinTable: FC<IProps> = ({ planId, callback }) => {
    const { t } = useLang('membersday.teaser.WinTable');
    const [isClient, setIsClient] = useState(false);
    const [tabActive, setTabActive] = useState('1');
    const { locale } = getLocal();
    const [listA, setListA] = useState<any[]>([]);
    const [listB, setListB] = useState<any[]>([]);

    const redEmailCallback = (list: any) => {
        const list2 = JSON.parse(JSON.stringify(list));
        const itemA = list2[0] || null;
        if (itemA) {
            const email1 = itemA.email || '';
            const email2 = email1.split('@');
            const name = email2[0] || email1;
            itemA.email = name;
        }
        return list2;
    };
    const initData = async () => {
        const data = {
            planId,
            lastMon: 0, // 当前月份的
        };
        const rankData = await getCurrentPlanTop(data, locale);
        if (tabActive === '1') {
            setListA(redEmailCallback(rankData?.data?.content || []));
        } else if (tabActive === '2') {
            setListB(rankData?.data?.content || []);
        }
    };

    useEffect(() => {
        setIsClient(true);
    }, []);

    useEffect(() => {
        planId && initData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabActive, planId]);

    if (!isClient) {
        return null;
    }
    const toggleHandle = (type: string) => {
        setTabActive(type);
    };

    return ReactDOM.createPortal(
        <div className={`glo-editor-modal glo-editor-modal-show ${styled.WinTable}`}>
            <div className="glo-editor-modal-wrap">
                <div className="modal-content">
                    <IconClose
                        className="win-close"
                        onClick={() => {
                            callback && callback();
                        }}
                    />
                    <div className="win-title">{t('title')}</div>
                    <div className="win-descTitle">{t('descTitle')}</div>
                    <div className={`tab-c-item ${tabActive === '1' ? ' tab-item-active' : ''}`}>
                        <div className="list-table">
                            <div className="list-table-tr list-table-thead">
                                <div className="list-table-td">{t('td1')}</div>
                                <div className="list-table-td">{t('td2')}</div>
                                <div className="list-table-td">{t('td3')}</div>
                            </div>
                            {listA.map((item: any, index: number) => {
                                return (
                                    <div className={`list-table-tr ${item.userId && 'active'}`} key={index}>
                                        <div className="list-table-td">
                                            <span className={`list-table-index list-table-index-${index + 1}`}>
                                                {item.ranking === 1 && <IconTop1 />}
                                                {item.ranking === 2 && <IconTop2 />}
                                                {item.ranking === 3 && <IconTop3 />}
                                                {item.ranking > 3 && <>{item.ranking || '-'}</>}
                                            </span>
                                        </div>
                                        <div className="list-table-td">{item.email}</div>
                                        <div className="list-table-td">{item.registerCount}</div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <div className={`tab-c-item ${tabActive === '2' ? ' tab-item-active' : ''}`}>
                        <div className="list-table">
                            <div className="list-table-tr list-table-thead">
                                <div className="list-table-td">{t('td1')}</div>
                                <div className="list-table-td">{t('td2')}</div>
                                <div className="list-table-td">{t('td3')}</div>
                            </div>
                            {listB.map((item: any, index: number) => {
                                return (
                                    <div className="list-table-tr" key={index}>
                                        <div className="list-table-td">
                                            <span className={`list-table-index list-table-index-${index + 1}`}>
                                                {index === 0 && <IconTop1 />}
                                                {index === 1 && <IconTop2 />}
                                                {index === 2 && <IconTop3 />}
                                                {index > 2 && <>{item?.ranking || index + 1}</>}
                                            </span>
                                        </div>
                                        <div className="list-table-td">{item.email}</div>
                                        <div className="list-table-td">{item.registerCount}</div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>,
        document.body,
    );
};

export default WinTable;
